function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import * as types from "../utils/types";
import { getField, getFieldset, isSelect, deepEquals, getSchemaType } from "../utils";
const COMPONENT_TYPES = {
  array: "ArrayField",
  boolean: "BooleanField",
  integer: "NumberField",
  number: "NumberField",
  object: "ObjectField",
  string: "StringField"
};

class SchemaField extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getFieldComponent", props => {
      const schema = props.schema,
            uiSchema = props.uiSchema,
            uiOptions = props.uiOptions,
            idSchema = props.idSchema,
            registry = props.registry;
      const fields = registry.fields;
      const field = uiOptions["field"];

      if (typeof field === "function") {
        return field;
      }

      if (typeof field === "string" && field in fields) {
        return fields[field];
      }

      const componentName = COMPONENT_TYPES[getSchemaType(schema)]; // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't

      if (!componentName && (schema.anyOf || schema.oneOf)) {
        return () => null;
      }

      const UnsupportedField = registry.fields.UnsupportedField;
      return componentName in fields ? fields[componentName] : () => {
        return React.createElement(UnsupportedField, {
          schema: schema,
          idSchema: idSchema,
          reason: "Unknown field type " + schema.type
        });
      };
    });

    _defineProperty(this, "renderComponent", props => {
      const schema = props.schema,
            uiSchema = props.uiSchema,
            registry = props.registry;
      const FieldComponent = this.getFieldComponent(props);
      const _AnyOfField = registry.fields.AnyOfField;
      const _OneOfField = registry.fields.OneOfField;
      return React.createElement(React.Fragment, null, React.createElement(FieldComponent, props), schema.anyOf && !isSelect(schema) && React.createElement(_AnyOfField, {
        disabled: props.disabled,
        errorSchema: props.errorSchema,
        formData: props.formData,
        idPrefix: props.idPrefix,
        idSchema: props.idSchema,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.anyOf,
        baseType: schema.type,
        registry: registry,
        safeRenderCompletion: props.safeRenderCompletion,
        uiSchema: uiSchema
      }), schema.oneOf && !isSelect(schema) && React.createElement(_OneOfField, {
        disabled: props.disabled,
        errorSchema: props.errorSchema,
        formData: props.formData,
        idPrefix: props.idPrefix,
        idSchema: props.idSchema,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.oneOf,
        baseType: schema.type,
        registry: registry,
        safeRenderCompletion: props.safeRenderCompletion,
        uiSchema: uiSchema
      }));
    });
  }

  shouldComponentUpdate(nextProps) {
    // if schemas are equal idSchemas will be equal as well,
    // so it is not necessary to compare
    return !deepEquals(_extends({}, this.props, {
      idSchema: undefined
    }), _extends({}, nextProps, {
      idSchema: undefined
    }));
  }

  render() {
    const props = getField(this.props);
    const registry = props.registry; // if fieldset, render fieldset

    /*
     const fieldset = getFieldset(props);
    const { SchemaFieldset } = registry.fields
     if (fieldset) {
        return (
            <SchemaFieldset {...fieldset} />
        )
    }
     */
    // render component

    return this.renderComponent(props);
  }

}

_defineProperty(SchemaField, "defaultProps", {
  uiSchema: {},
  idSchema: {},
  errorSchema: {},
  disabled: false,
  readonly: false,
  autofocus: false
});

SchemaField.propTypes = process.env.NODE_ENV !== "production" ? {
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  idSchema: PropTypes.object,
  formData: PropTypes.any,
  errorSchema: PropTypes.object,
  registry: types.registry.isRequired
} : {};
export default SchemaField;